import { AuthenticationService } from './auth/_services/authentication.service';
import { Component, OnInit, ViewEncapsulation, HostListener, Inject } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { Helpers } from "./helpers";
import { Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
@Component({
    selector: 'body',
    templateUrl: './app.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {
    title = 'app';
    //  globalBodyClass = 'm-page--loading-non-block m-page--wide m-header--fixed m-header--fixed-mobile m-aside-left--enabled m-aside-left--offcanvas m-footer--push m-aside--offcanvas-default';

    constructor(private _router: Router, private _authService: AuthenticationService, private renderer: Renderer2,
        @Inject(DOCUMENT) private document: any) {
        //this._permissionService.define(['ViewUsers', 'CreateUser', 'EditUser', 'DeleteUser']);
        //this._permissionService.add('ViewUsers');

    }

    ngOnInit() {
        this.setFaviconBasedOnTheme();

        // Watch for theme changes if browser supports it
        if (window.matchMedia) {
            const matcher = window.matchMedia('(prefers-color-scheme: dark)');
            if (matcher.addListener) {
                // Old syntax for older browsers
                matcher.addListener(function() {
                    // Call with context of this
                    this.setFaviconBasedOnTheme();
                }.bind(this));
            }
        }

        this._router.events.subscribe((route) => {
            if (route instanceof NavigationStart) {
                Helpers.setLoading(true);
                //  Helpers.bodyClass(this.globalBodyClass);
            }
            if (route instanceof NavigationEnd) {
                Helpers.setLoading(false);
            }
        });
    }

    setFaviconBasedOnTheme() {
        const isDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

        const faviconPath = isDark
            ? 'assets/images/favicon-white.png'
            : 'assets/images/favicon-black.png';

        this.updateFavicon(faviconPath);
    }

    updateFavicon(href: string) {
        let link = this.document.querySelector("link[rel*='icon']");
        if (!link) {
            link = this.renderer.createElement('link');
            this.renderer.setAttribute(link, 'rel', 'icon');
            this.renderer.appendChild(this.document.head, link);
        }
        this.renderer.setAttribute(link, 'type', 'image/x-icon');
        this.renderer.setAttribute(link, 'href', href);
    }
    // @HostListener('window:unload', ['$event'])
    // unloadHandler(event) {


    // }

    // @HostListener('window:beforeunload', ['$event'])
    // beforeUnloadHander(event) {

    //     let currentUrl: string;
    //     currentUrl = window.location.pathname;
    //     if (currentUrl.includes('/payment')) {
    //     } else {
    //         this._authService.logout();

    //     }
    // }

}


// WEBPACK FOOTER //
// ./src/app/app.component.ts